<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    // mounted() {
    //   // 在 main.js 或 App.vue 的 mounted 中添加
    //   document.addEventListener('keydown', function (e) {
    //     // 禁用 F12
    //     if (e.key === 'F12') {
    //       e.preventDefault();
    //       return false;
    //     }
    //
    //     // 禁用 Ctrl+Shift+I (Chrome/Edge)
    //     if (e.ctrlKey && e.shiftKey && e.key === 'I') {
    //       e.preventDefault();
    //       return false;
    //     }
    //
    //     // 禁用 Ctrl+Shift+J (Chrome/Edge)
    //     if (e.ctrlKey && e.shiftKey && e.key === 'J') {
    //       e.preventDefault();
    //       return false;
    //     }
    //
    //     // 禁用 Ctrl+U (查看源代码)
    //     if (e.ctrlKey && e.key === 'u') {
    //       e.preventDefault();
    //       return false;
    //     }
    //   });
    //
    //   // 禁用右键菜单
    //   document.addEventListener('contextmenu', function (e) {
    //     e.preventDefault();
    //     return false;
    //   });
    // }
  }
</script>

<style lang="less">
  /*滚动条设置*/
  ::-webkit-scrollbar {
    width: 0px;
  }

  ::-webkit-scrollbar-track {
    background: #041954;
  }

  ::-webkit-scrollbar-thumb {
    background: #041954;
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box; // 自适应核心
    user-select: none !important; /* 禁止所有元素被选中、不显示光标 */
  }

  // html + body 全屏
  html,
  body {
    width: 100%;
    height: 100%;
    background-color: #041954; // 你要的深蓝色背景
    overflow: hidden; // 禁止全局滚动条
  }

  // 根容器 100% 自适应
  #app {
    width: 100%;
    height: 100vh; // 自适应屏幕高度
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>
